import { render, staticRenderFns } from "./notulensi-kegiatan.vue?vue&type=template&id=6d9ad48d&"
import script from "./notulensi-kegiatan.vue?vue&type=script&lang=js&"
export * from "./notulensi-kegiatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports